import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { DataTablePagination, Hospital, AnestesistaHospital } from '@/types/_'
import Apis from '@/Apis/_'

type Mode = 'CREATE' | 'EDIT'

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  anestesistas: boolean,
}

@Module({ namespaced: true, name: 'SuporteAnestesistasStore' })
export default class SuporteAnestesistasStore extends VuexModule {
  public hospitais: Hospital[] = []
  public hospitalId: string = ''
  public searchAnestesistasHospital: string = ''

  public mode: Mode = 'CREATE'

  public modal: SuporteModal = {
    anestesistas: false,
  }

  @Mutation
  setSearchAnestesistasHospital(value: string) {
    this.searchAnestesistasHospital = value
  }

  @Mutation
  clearSearchAnestesistasHospital() {
    this.searchAnestesistasHospital = ''
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitais(value: Hospital[]) {
    this.hospitais = value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitais() {
    this.hospitais = []
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setMode(param: any) {
    this.mode = param.mode
  }

  @Action
  forceCast<T>(obj: any) {
    return obj
  }

  @Action({ commit: 'setHospitais' })
  async getHospitais() {
    const request = await Apis.Agendamento.SuporteApi.getHospitaisByUserCurrent()
    if (request.success) {
      const data = request.data.map((c: any) => {
        const hospital = c
        hospital.id = _.toUpper(c.id)
        hospital.nome = _.toUpper(c.nome)
        return hospital
      })
      const hospitaisCast = await this.forceCast<Hospital[]>(data)
      return hospitaisCast
    }
    return []
  }

  /** Anestesistas */
  private paginaDefault: number = 1
  private qtdPorPaginaDefault: number = 10
  public totalAnestesistas: number = 0
  public totalAnestesistasHospital: number = 0
  public pagina: number = this.paginaDefault
  public qtdPorPagina: number = this.qtdPorPaginaDefault

  @Mutation
  setTotalAnestesistas(value: number) {
    this.totalAnestesistas = value
  }

  @Mutation
  setTotalAnestesistasHospital(value: number) {
    this.totalAnestesistasHospital = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setQtdPorPagina(value: number) {
    this.qtdPorPagina = value
  }

  @Mutation
  clearPagination() {
    this.pagina = this.paginaDefault
    this.qtdPorPagina = this.qtdPorPaginaDefault
  }

  public anestesistas: AnestesistaHospital[] = []
  public anestesistasHospital: AnestesistaHospital[] = []

  @Mutation
  setAnestesistas(value: AnestesistaHospital[]) {
    this.anestesistas = value
  }

  @Mutation
  clearAnestesistas() {
    this.anestesistas = []
  }

  @Mutation
  setAnestesistasHospital(value: AnestesistaHospital[]) {
    this.anestesistasHospital = value
  }

  @Mutation
  clearAnestesistasHospital() {
    this.anestesistasHospital = []
  }

  @Action
  async getAllAnestesistas(searchText: string = '') {
    try {
      const { pagina, qtdPorPagina } = this
      const request = await Apis.Agendamento.SuporteApi.getAllAnestesistas({ searchText, pagina, qtdPorPagina })
      if (request.success) {
        this.context.commit('setAnestesistas', request.data.anestesistas as AnestesistaHospital[] || [])
        this.context.commit('setTotalAnestesistas', request.data.total as number || 0)
      }
      return request
    } catch (error) {
      this.context.commit('setAnestesistas', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getAllAnestesistasByHospitalId() {
    try {
      const { pagina, qtdPorPagina, hospitalId, searchAnestesistasHospital } = this
      if (searchAnestesistasHospital.length < 5) return { success: false, message: 'É necessário informar o nome do Anestesista com no mínimo 5 caracteres' }
      const request = await Apis.Agendamento.SuporteApi.getAllAnestesistasByHospitalId({ hospitalId, searchText: searchAnestesistasHospital, pagina, qtdPorPagina })
      if (request.success) {
        this.context.commit('setAnestesistasHospital', request.data.anestesistas as AnestesistaHospital[] || [])
        this.context.commit('setTotalAnestesistasHospital', request.data.total as number || 0)
      }
      return request
    } catch (error) {
      this.context.commit('setAnestesistas', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async postAnestesista(params: any) {
    try {
      const request = await Apis.Agendamento.SuporteApi.postAnestesista(params)
      if (request.success) await this.context.dispatch('getAllAnestesistas')
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async postAnestesistaToHospital(params: any) {
    try {
      const payload: any = {
        hospitalId: this.hospitalId,
        anestesistaId: params.anestesistaId,
      }
      const request = await Apis.Agendamento.SuporteApi.postAnestesistaToHospital(payload)
      // if (request.success) await this.context.dispatch('getAllAnestesistas')
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
